import { render, staticRenderFns } from "./ModalLote.vue?vue&type=template&id=8d067610&"
import script from "./ModalLote.vue?vue&type=script&lang=js&"
export * from "./ModalLote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports